
import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import api from '@/api';

const { member } = api;

@Component({ components: { Dialog } })
export default class UserForgotPassword extends Vue {
  @Prop() private userId!: string;

  private loading = false;

  private async ok() {
    this.loading = true;
    const { status } = await member.forgotPassword(this.userId);

    if (status === 1) {
      await this.back();
    }

    this.loading = false;
  }

  private async back() {
    await this.$router.back();
  }
}
